import React, { useState } from "react";
import OverviewSection from "./OverviewSection";
import i18n from "~/assets/js/Helpers/i18n";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { unpackAreaCookie } from "~/assets/js/Format";
import {
    updateLocation,
    dispatchLocationChange,
} from "~/assets/js/Api/storeApi";
import PropTypes from "prop-types";
import AddressPopup from "~/assets/js/components/AddressPopup";

const TypeOfOrder = ({ edit }) => {
    const [overlayOpen, setOverlayOpen] = useState(false);

    const submitData = async (
        area_update,
        location_update,
        address_update,
        shouldCloseOverlay = true
    ) => {
        const data = {
            area: area_update,
            location: location_update,
            address: address_update,
        };

        dispatchLocationChange(data);

        shouldCloseOverlay && setOverlayOpen(false);
        const success = await updateLocation();
        if (!success) {
            return context.dispatch(
                AddToast("danger", i18n.t("toasts.locationUpdate.error"))
            );
        }

        return;
    };

    const onEdit = () => {
        setOverlayOpen(true);
    };

    return (
        <>
            {overlayOpen && (
                <AddressPopup
                    setOpen={setOverlayOpen}
                    submitData={submitData}
                />
            )}
            <OverviewSection
                title="overview.orderType"
                editPage={edit && onEdit}
            >
                <OrderTypeToggleBox />
            </OverviewSection>
        </>
    );
};

export const OrderTypeToggleBox = () => {
    const cookie = useAreaCookie();
    const orderType = unpackAreaCookie(cookie);

    if (!orderType) {
        return null; // TODO: maybe add some default value
    }

    const deliveryText = `${i18n.t("delivery.delivery")} ${i18n.t(
        "delivery.to"
    )} ${orderType.location}`;

    const pickupText = `${i18n.t("delivery.pickup")} ${i18n.t("delivery.in")} ${
        orderType.location
    }`;

    const { iconPath } = reactConfig;

    const icon = orderType.isDelivery
        ? `${iconPath}/bicycle-new.svg`
        : `${iconPath}/shop-new.svg`;

    const text = orderType.isDelivery ? deliveryText : pickupText;
    return (
        <div className="togglebox">
            <img src={icon} className={"togglebox__icon"}></img>
            <span className="togglebox__title ph-no-capture">{text}</span>
        </div>
    );
};

TypeOfOrder.propTypes = {
    edit: PropTypes.bool.isRequired,
};

export default TypeOfOrder;
